<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showNonconformanceType"
                                perm="configuration.create"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetNonconformanceTypes()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="nonconformance_types"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :class="{ 'prevent-click': !hasPerm('configuration.update') }"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showNonconformanceType(props.item)">
								<td>{{ props.item.type }}</td>
								<td>{{ props.item.description }}</td>
								<td>{{ props.item.scenario }}</td>
								<td>{{ props.item.active_flag }}</td>
								<td>
                                    <div
                                        class="white--text pa-2 text-center mx-auto border-rad-8"
                                        style="width:100px;"
                                        :class="`${props.item.chip_color} darken-1`"
                                    >
                                        {{ props.item.chip_color }}
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="settings_nonconformance_types"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="nonconformance_type_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('nonconformance_type_id') ? $t('lang.edit_nonconformance_type') : $t('lang.add_nonconformance_type') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeNonconformanceTypeDialog"
                            :dialog-status="nonconformance_type_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="nonconformance_types">
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="nonconformance_type_dialog"
											v-model="nonconformance_type.type"
											:label="`${$t('lang.type')} *`"
											:counter="showCounter(nonconformance_type.type, 'nonconformance_types.type')"
											:rules="ifValid('nonconformance_types.type', { nonconformance_type_id: currObjField('nonconformance_type_id') })"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-textarea
											v-model="nonconformance_type.description"
											:label="$t('lang.description')"
											auto-grow
											rows="1"
											:rules="ifValid('nonconformance_types.description')"
										></v-textarea>
									</v-flex>
									<v-flex xs12>
										<v-textarea
											v-model="nonconformance_type.scenario"
											:label="$t('lang.scenario')"
											auto-grow
											rows="1"
											:rules="ifValid('nonconformance_types.scenario')"
										></v-textarea>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="nonconformance_type.active_flag"
											:label="`${$t('lang.active_flag')} *`"
											:items="active_flag"
											item-value="value"
											item-text="text"
											:rules="ifValid('nonconformance_types.active_flag')"
										></bc-select>
									</v-flex>
									<v-flex xs12>
                                        <bc-select
											v-model="nonconformance_type.chip_color"
                                            :label="`${$t('lang.chip_color')} *`"
                                            :items="nonconformance_colors"
                                            :rules="ifValid('nonconformance_types.chip_color')"
                                        >
                                            <template slot="item" slot-scope="data">
                                                <span class="py-3 px-2 w-100" :class="`${data.item} darken-1 white--text`">
                                                    {{ data.item }}
                                                </span>
                                            </template>
                                            <template slot="selection" slot-scope="data">
                                                <span class="py-1 px-2 w-100" :class="`${data.item} darken-1 white--text`">
                                                    {{ data.item }}
                                                </span>
                                            </template>
                                        </bc-select>
									</v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('nonconformance_type_id') && hasPerm('configuration.delete')" color="error" @mouseup.left="openDelete()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeNonconformanceTypeDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyNonconformanceType(currObjField('nonconformance_type_id') ? 'patch' : 'post', currObjField('nonconformance_type_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_nonconformance_types"
                :heading="$t('lang.delete_nonconformance_type')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyNonconformanceType('delete', currObjField('nonconformance_type_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.type"), sortable: false, width: "20%" },
                { text: this.$t("lang.description"), sortable: false, width: "20%" },
                { text: this.$t("lang.scenario"), sortable: false, width: "20%" },
                { text: this.$t("lang.active_flag"), sortable: false, width: "20%" },
                { text: this.$t("lang.chip_color"), sortable: false, width: "20%", align: "center" },
            ],
            nonconformance_colors: [
                "red",
                "pink",
                "purple",
                "deep-purple",
                "indigo",
                "blue",
                "light-blue",
                "cyan",
                "teal",
                "green",
                "light-green",
                "lime",
                "yellow",
                "amber",
                "orange",
                "deep-orange",
                "brown",
                "blue-grey",
            ],
            nonconformance_type: {
                type: "",
                description: "",
                scenario: "",
                active_flag: "",
                chip_color: "",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            nonconformance_type_dialog: false,
            active_flag: [{ text: this.$t("lang.yes"), value: "1" }, { text: this.$t("lang.no"), value: "0" }],
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showNonconformanceType", perms: ["configuration.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetNonconformanceTypes" },
            ],
            dbGetNonconformanceTypes: _.debounce(this.getNonconformanceTypes, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchNonconformance", {
                url: "nonconformance_types",
                method: "get",
                stateProperty: "nonconformance_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformance_types) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchNonconformance", {
                url: "nonconformance_types",
                method: "get",
                stateProperty: "nonconformance_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformance_types) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_nonconformance_types: (state) => state.validation.rules_nonconformance_types,
            default_filter: (state) => state.nonconformance.nonconformance_types_filter,
            page: (state) => state.nonconformance.page,
            nonconformance_types: (state) => state.nonconformance.nonconformance_types,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        openDelete() {
            this.$refs.delete_nonconformance_types.openDialog();
        },
        closeNonconformanceTypeDialog() {
            this.nonconformance_type_dialog = false;
            this.$refs.delete_nonconformance_types.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getNonconformanceTypes() {
            this.startLoader();
            this.$store
                .dispatch("fetchNonconformance", {
                    url: "nonconformance_types",
                    method: "get",
                    stateProperty: "nonconformance_types",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.nonconformance_type_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyNonconformanceType(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("nonconformance_types")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchNonconformance", {
                                pk: "nonconformance_type_id",
                                id: id,
                                url: `nonconformance_types/${id ? id : ""}`,
                                method: method,
                                stateProperty: "nonconformance_types",
                                mutate: true,
                                body: this.nonconformance_type,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeNonconformanceTypeDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showNonconformanceType(item = null) {
            this.current_obj = item;

            if (this.$refs.nonconformance_types) item ? this.$refs.nonconformance_types.resetValidation() : this.$refs.nonconformance_types.reset();

            this.$nextTick(() => {
                this.assignObj(this.nonconformance_type, item, this.rules_nonconformance_types);
                this.nonconformance_type_dialog = true;
            });
        },
    },
};
</script>
